import PlacePreview from './PlacePreview';

export default PlacePreview;
